import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cx } from '../cx'
import styles from './Button.module.css'

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'danger'

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  children: ReactNode
  variant?: ButtonVariant
  /** Full-width pill — the shape the spec pins low for thumb reach (§4, §6). */
  fullWidth?: boolean
  className?: string | undefined
}

/**
 * Spec §4 "Buttons". Primary is the ember gradient with a near-black label;
 * minimum height 48px, full radius. Destructive / GM actions use `outline`.
 */
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.btn, styles[variant], fullWidth && styles.full, className)}
      {...rest}
    >
      {children}
    </button>
  )
}
